<template>
  <button
    :class="renderClass"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <div v-if="circleLight" :class="modelValue ? 'circle-light' : null"></div>
    {{ label }}
  </button>
</template>

<script>
export default {
  name: "BaseButton",
  ///////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////
  props: {
    id: [String, Number],
    label: [String, Boolean],
    classType: String,
    classState: String,
    modelValue: [Number, Boolean, String, Object],
    isReverted: { type : Boolean, default: false },
    circleLight: {
      type: Boolean,
      default: false
    }
  },
  ///////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////
  data() {
    return {
      hover: false,
    };
  },
  ///////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////
  emits: ["update:modelValue"],
  ///////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////
  computed: {
    renderIsActive: function () {
      if (!this.isActivable) return false;

      if (this.dataType === "toggle" && this.modelValue)
        return this.modelValue ? true : false;
      else if (this.dataType === "toggleInverted")
        return this.modelValue ? false : true;
      else if (this.isActive) return true;
      else return false;
    },
    ///////////////////////////////////////////////////////////////////////////////
    renderClass: function () {
      let newClass = this.classState;

      newClass += this.hover ? ' hover' : '';
      return newClass;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/lib/tui/scss/module/baseButton.scss";
</style>
